import './App.css';

function JoinUs() {
  return (
    <section className="hero" style={{ paddingTop: 32 }}>
      <h1 className="hero-title">Join our network of specialists</h1>
      <p className="hero-subtitle">We collaborate with outstanding engineers, researchers, designers, and product leaders.</p>
      <div style={{ marginTop: 16, maxWidth: 700 }}>
        <ul>
          <li>Send your LinkedIn and a short note on your expertise</li>
          <li>Highlight notable work, publications, OSS, or patents</li>
          <li>Tell us the types of projects you’re excited about</li>
        </ul>
      </div>
      <div style={{ marginTop: 16 }}>
        For invitations and collaboration, contact: <code className="contact-address">mim3dot @ gmail . com</code>
      </div>
    </section>
  );
}

export default JoinUs;
